<template>
	<div class="[&_svg]:w-8xl [&_svg]:h-8x">
		<slot />
	</div>
</template>
